import { lazy } from 'react';

export default lazy(() =>
  import(
    /* webpackChunkName: 'supplier_tables_details_page' */ './SupplierTablesDetailsPage'
  ),
);
